import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import { PDPAvailabilityNotificationProductVariantT, PDPAvailabilityNotificationsTranslationsProps } from "./types";
import { SimpleAspectRatio } from "../../../../../components/_shared-components/SimpleAspectRatio";
import { css } from "@emotion/react";
import { ContentfulImage2 } from "../../../../../components/_shared-components/image-related/ContentfulImage2";
import { fontColor, FONTS, fontSize } from "../../../../../styles/fonts";
import { CSS_COLORS } from "../../../../../styles/styles-css-variables";
import React from "react";
import { CSS_MQ } from "../../../../../styles/breakpoints";
import { T } from "../../../../../components/T";
import type { TranslatedValue } from "@swo/storefront";

export const PDPAvailabilityNotificationProductInfo: ReactTFC<{
  variant: PDPAvailabilityNotificationProductVariantT;
  translations: PDPAvailabilityNotificationsTranslationsProps;
  startingPrice: React.ReactElement | TranslatedValue;
}> = props => {
  const { variant, translations } = props;

  return (
    <>
      <SimpleAspectRatio
        css={css`
          --aspect-ratio: calc(1 / 2);

          margin-bottom: 20px;

          ${CSS_MQ.atMostMd} {
            width: 100%;
            max-height: 150px;
          }
          ${CSS_MQ.atLeastLg} {
            width: 80%;
          }
          align-self: center;

          ${CSS_MQ.lowResNotebook} {
            max-height: 75px;
          }
        `}
      >
        <ContentfulImage2
          assetId={variant.image?.sys.id}
          contentfulUrl={variant.image?.url}
          withTransparency={true}
          alt={variant.image?.description || undefined}
          css={css`
            width: 100%;
            height: 100%;
            object-fit: contain;
          `}
          sizes="(max-width: 575px) 200px, 300px"
          cropping={undefined}
        />
      </SimpleAspectRatio>

      <span
        css={css`
          ${FONTS.SwarovskiFutura300};

          font-size: 24px;
          ${CSS_MQ.atLeastSm} {
            font-size: 30px;
          }
          color: ${CSS_COLORS.Green};
          text-align: center;
        `}
      >
        {variant.name}
      </span>

      <span
        css={css`
          //margin-top: 4px;
          margin-bottom: 20px;

          ${FONTS.SwarovskiFutura500};
          ${fontColor.black};

          font-size: 16px;
          letter-spacing: 1px;
          text-align: center;
        `}
      >
        <T>{props.startingPrice}</T>
      </span>

      <p
        css={[
          FONTS.SwarovskiFutura300,
          fontSize.x2,
          css`
            text-align: center;

            margin-top: 0;
            margin-bottom: 20px;
          `,
        ]}
      >
        <T>{translations.availabilityNotificationSpamInfoLabel}</T>
      </p>
    </>
  );
};
